/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ project: NonNullable<unknown> }} Chat_Artifact_Confirm_Target_ProjectInputs */



/**
* | output |
* | --- |
* | "Into another project: {project}" |
*
* @param {Chat_Artifact_Confirm_Target_ProjectInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_artifact_confirm_target_project = /** @type {((inputs: Chat_Artifact_Confirm_Target_ProjectInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Artifact_Confirm_Target_ProjectInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`In ein anderes Projekt: ${i?.project}`)
	return /** @type {LocalizedString} */ (`Into another project: ${i?.project}`)
});